import { ActionReducer, ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '../../environments/environment';
import { routerReducer } from '@ngrx/router-store';
import { trackReducer } from '../component/session-tracking/tracking.reducer';

export interface AppState {}

export const reducers: ActionReducerMap<AppState> = {
    router: routerReducer,
    tracks: trackReducer
};

export function logger(reducer: ActionReducer<any>): ActionReducer<any> {
    return (state, action) => {
        if (action.type === '[Top Menu] Logout') {
            return reducer(undefined, action);
        }
        return reducer(state, action);
    };
}

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [logger] : [];
